import { Chart } from 'react-chartjs-2';
import { useGetByIdAndTimeSummarizedQuery } from '../../../services/historicalData';
import { useEffect, useMemo, useState } from 'react';
import { useGetMediumColor } from '../../../hooks/useGetMediumColor';
import { Block } from 'baseui/block';
import { addDays, addMonths, format } from 'date-fns';
import { FormattedMessage, useIntl } from 'react-intl';
import { datasetFromData, ITypeAndData } from './utils';
import { ICounter } from '../../Devices/Counter';
import { useStyletron } from 'baseui';
import { Banner } from 'baseui/banner';
import { defaultOptions } from './defaultOptions';
import { useGetLanguage } from '../../../hooks/useGetLanguage';
import React from 'react';
import { ISensorAnalog } from '../../Devices/SensorAnalog';
import { HistoricalDataItemGroup } from '../../../services/historicalData';
import { themedUseStyletron } from '../../../theme/customTheme';

export interface COPChartProps {
    counterIn: any[],
    counterOut: any[],
    temperatur: any[]
}
interface IState {
    start: Date,
    end: Date,
    datasets: any[],
}

function COPChart({ counterIn, counterOut, temperatur }: COPChartProps) {
    const intl = useIntl();
    const { locale } = useGetLanguage();
    const [, theme] = themedUseStyletron();
    const current = new Date();
    const [state, setState] = useState<IState>({
        start: addMonths(new Date(current.getFullYear(), current.getMonth(), current.getDate()), -12),
        end: addDays(new Date(current.getFullYear(), current.getMonth(), current.getDate()), 1),
        datasets: []
    });

    const myOptions = { ...defaultOptions };
    myOptions.scales.x.adapters = {
        date: {
            locale: locale
        }
    };

    // update every x seconds
    useEffect(() => {
        const interval = setInterval(() => UpdateTimes(), 60 * 1000); // every 5 minutes
        return () => {
            clearInterval(interval);
        };
    });
    function UpdateTimes() {
        setState((prev) => ({
            ...prev,
            start: addMonths(new Date(current.getFullYear(), current.getMonth(), current.getDate()), -12),
            end: addDays(new Date(current.getFullYear(), current.getMonth(), current.getDate()), 1),
        }));
    }

    const { data: data1 } = useGetByIdAndTimeSummarizedQuery(
        {
            id: counterIn[0]?.id,
            resourceGroupId: counterIn[0]?.resourceGroupId,
            propertyName: 'valueDelta',
            start: state.start.toISOString(),
            end: state.end.toISOString(),
            summarizeBy: 'month'
        });
    const { data: data2 } = useGetByIdAndTimeSummarizedQuery(
        {
            id: counterOut[0]?.id,
            resourceGroupId: counterOut[0]?.resourceGroupId,
            propertyName: 'valueDelta',
            start: state.start.toISOString(),
            end: state.end.toISOString(),
            summarizeBy: 'month'
        });
    const { data: dataOT } = useGetByIdAndTimeSummarizedQuery(
        {
            id: temperatur[0]?.id,
            resourceGroupId: temperatur[0]?.resourceGroupId,
            propertyName: 'value',
            start: state.start.toISOString(),
            end: state.end.toISOString(),
            summarizeBy: 'month'
        });


    useEffect(() => {
        if (!data1 || !data2 || data1.length == 0 || data2.length == 0 )
            return;

        var arr2 = [...data2]
        if ( data2.length > data1.length)
            arr2.splice(0, data2.length - data1.length)

        var arr1 = [...data1]
        if ( data1.length > data2.length)
           arr1.splice(0, data1.length - data2.length)

        const newData = arr2.map(function(x, index)
        {   
            const cOP = arr1[index]?.sumValue / x.sumValue; 
            const newItem : HistoricalDataItemGroup = { 
                timeStamp : x.timeStamp,
                objectId : x.objectId,
                propertyName : x.propertyName,
                sumValue : cOP,
                minValue : cOP,
                maxValue : cOP,
                avgValue : cOP
            }
            return newItem});

        var datas: ITypeAndData[] = [];
        datas.push({ lable: 'SCOP', y: 'y', color: theme.appColors.measurments.default, data: newData ?? [] });
        datas.push({ lable: intl.formatMessage({ id: "heatpumpCOP.outsideTemperature", defaultMessage: "OutsideTemperature" }), y: 'y1', color: theme.appColors.measurments.temperature, data: dataOT ?? [] });

        const dscounters = datas.map((item, index) => datasetFromData(item, intl));

        setState((prev) => ({
            ...prev,
            datasets: dscounters,
        }));

    }, [data1, data2, dataOT])


    const data = useMemo(() => {
        const tmp = {
            datasets: state.datasets,
        }
        return tmp;
    }, [data1, state.datasets]);



    return (
        <Block width={'100%'} display='flex' flexDirection='column' alignItems='center' gridRowGap={theme.sizing.scale300}>
                <>
                    {<Chart type='line' data={data} options={myOptions} />}
                </>

        </Block>
    );
}


export default React.memo(COPChart)
